import { render, staticRenderFns } from "./showActivitiesEdition.vue?vue&type=template&id=57547752"
import script from "./showActivitiesEdition.vue?vue&type=script&lang=js"
export * from "./showActivitiesEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports